interface VideoModalProps {
    isOpen: boolean;
    onClose: () => void;
    videoUrl: string;
}

export function VideoModal({ isOpen, onClose, videoUrl }: VideoModalProps) {
    if (!isOpen) return null;

    return (
        <div
            className='z-overlay-content fixed inset-0 flex items-center justify-center'
            style={{ background: 'var(--modal-overlay-color)' }}
            onClick={onClose}
        >
            <div className='w-full max-w-4xl px-4' onClick={e => e.stopPropagation()}>
                <iframe
                    src={videoUrl}
                    title='Video'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                    className='aspect-video w-full rounded-lg'
                />
            </div>
        </div>
    );
}
